module.exports = __webpack_public_path__ + "static/img/qs.8707088d.png";